
import React from 'react';
import { Link } from 'react-router-dom';

function SkillSection() {
  return (
    <div className="our-skill">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="our-skill-images">
              <div className="our-skill-image-1">
                <figure className="image-anime reveal">
                  <img src="/hellotruck-web-images/our-skill-image-1.jpg" alt="" />
                </figure>
              </div>

              <div className="our-skill-image-2">
                <figure className="image-anime reveal">
                  <img src="/hellotruck-web-images/our-skill-image-2.jpg" alt="" />
                </figure>
              </div>

              <div className="contact-us-circle">
                <Link to="/contact">
                  <img src="/hellotruck-web-images/contact-us-circle.svg" alt="" />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="our-skill-content">
              <div className="section-title">
                <h3 className="wow fadeInUp">our skill</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">Experienced movers with a passion <span>for perfection</span></h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">Our team is equipped with the skills and expertise to handle every aspect of your move. From meticulous packing to careful transportation, we ensure your belongings are treated.</p>
              </div>

              <div className="our-skill-body">
                <div className="skills-progress-bar">
                  <div className="skillbar" data-percent="85%">
                    <div className="skill-data">
                      <div className="skill-title">Affordable Pricing</div>
                      <div className="skill-no">85%</div>
                    </div>
                    <div className="skill-progress">
                      <div className="count-bar"></div>
                    </div>
                  </div>
                </div>

                <div className="skills-progress-bar">
                  <div className="skillbar" data-percent="95%">
                    <div className="skill-data">
                      <div className="skill-title">specialized handling</div>
                      <div className="skill-no">95%</div>
                    </div>
                    <div className="skill-progress">
                      <div className="count-bar"></div>
                    </div>
                  </div>
                </div>

                <div className="skills-progress-bar">
                  <div className="skillbar" data-percent="96%">
                    <div className="skill-data">
                      <div className="skill-title">customer-centered approach</div>
                      <div className="skill-no">96%</div>
                    </div>
                    <div className="skill-progress">
                      <div className="count-bar"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="our-skill-btn wow fadeInUp" data-wow-delay="0.4s">
                <Link to="/contact" className="btn-default">book service now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SkillSection;
